/**
 * @generated SignedSource<<328bd195773e04880c76afc490c2d381>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProductPeriodOrderInput = {
  ordering: number;
  periodText: string;
};
export type productPeriodOrder_productPeriodOrdersUpdateMutation$variables = {
  orders: ReadonlyArray<ProductPeriodOrderInput>;
};
export type productPeriodOrder_productPeriodOrdersUpdateMutation$data = {
  readonly productPeriodOrdersUpdate: ReadonlyArray<{
    readonly ordering: number | null;
    readonly periodText: string;
  }>;
};
export type productPeriodOrder_productPeriodOrdersUpdateMutation = {
  response: productPeriodOrder_productPeriodOrdersUpdateMutation$data;
  variables: productPeriodOrder_productPeriodOrdersUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orders"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orders",
        "variableName": "orders"
      }
    ],
    "concreteType": "ProductPeriodOrder",
    "kind": "LinkedField",
    "name": "productPeriodOrdersUpdate",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "periodText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ordering",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productPeriodOrder_productPeriodOrdersUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productPeriodOrder_productPeriodOrdersUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "491b7a89a16a28677c3eae0fd0395f88",
    "id": null,
    "metadata": {},
    "name": "productPeriodOrder_productPeriodOrdersUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation productPeriodOrder_productPeriodOrdersUpdateMutation(\n  $orders: [ProductPeriodOrderInput!]!\n) {\n  productPeriodOrdersUpdate(orders: $orders) {\n    periodText\n    ordering\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1778702f30fd514aea22dc271c428a2";

export default node;
